import { render, staticRenderFns } from "./GigPalette.htm?vue&type=template&id=0e744341&scoped=true&"
import script from "./GigPalette.ts?vue&type=script&lang=js&"
export * from "./GigPalette.ts?vue&type=script&lang=js&"
import style0 from "./GigPalette.scss?vue&type=style&index=0&id=0e744341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e744341",
  null
  
)

export default component.exports